import { useQuery } from "react-query";
import {
	getCommonMetaDataShareHolder,
	getCompanySummary,
	getDataShareHolder,
	getListCompanyDetailCorporate,
	getListCompliance,
	getListDocuments,
	getListProgressCorporate,
	getMetaDataShareHolder,
	getMetadataDocument,
} from "./request";

export const useGetMetaDataShareHolder = () => {
	return useQuery<any>(["/metadata/corporate-investors"], getMetaDataShareHolder);
};

export const useGetCommonMetaDataShareHolder = () => {
	return useQuery<any>(["/metadata/v2"], getCommonMetaDataShareHolder);
};

export const useGetDataShareHolder = () => {
	return useQuery<any>(["api/corporate-investors/actor"], () => getDataShareHolder());
};
export const useGetListProgressCorporate = (options?: any) => {
	return useQuery<any>(["/corporate-investors/progress"], getListProgressCorporate, options);
};
export const useGetListCompanyDetailCorporate = () => {
	return useQuery<any>(["/corporate-investors/profile"], getListCompanyDetailCorporate);
};
export const useGetCompanySummary = () => {
	return useQuery<any>(["api/corporate-investors/summary"], () => getCompanySummary());
};

export const useGetCompliance = () => {
	return useQuery<any>(["/corporate-investors/compliance"], () => getListCompliance());
};

export const useGetMetadataDocument = () => {
	return useQuery<any>(["api/corporate-investors/actor"], getMetadataDocument);
};

export const useGetDataDocument = () => {
	return useQuery<any>(["api/corporate-investors/actor"], getListDocuments);
};
